import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: any) => ({
  card: {
    width: '100%',
    height: '100%',
    minHeight: '220px',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: "#f7f0f1",
    '&:hover': {
      border: `2px solid ${theme.palette.primary.main}`,
    },
    '&:active': {
      backgroundColor: theme.palette.primary.light,
    },
    [theme.breakpoints.only('xs')]: {
      display: 'flex',
      minHeight: '220px',
    },
  },
  cardMedia: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '150px',
    width: '100%',
    padding: theme.spacing(2),
    objectFit: 'contain',
    [theme.breakpoints.only('xs')]: {
      width: '100%',
      height: '150px',
    },
  },
  cardContent: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    [theme.breakpoints.only('xs')]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  link: {
    textDecoration: 'none',
  },
  label: {
    fontWeight: theme.typography.fontWeightBold,
    borderColor: '#d32f2f !important',
    color: '#d32f2f !important',
    textTransform: 'uppercase',
    fontSize: '0.85rem',
    padding: '10px 10px',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    minHeight: 'auto',
    height: 'auto',
    lineHeight: 1.3,
    backgroundColor: 'white',
    [theme.breakpoints.only('xs')]: {
      fontSize: '0.75rem',
      padding: '6px 10px',
    },
  },
}));
